import { render, staticRenderFns } from "./MarkdownInfo.vue?vue&type=template&id=1f6145da&scoped=true"
import script from "./MarkdownInfo.vue?vue&type=script&lang=js"
export * from "./MarkdownInfo.vue?vue&type=script&lang=js"
import style0 from "./MarkdownInfo.vue?vue&type=style&index=0&id=1f6145da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6145da",
  null
  
)

export default component.exports